import * as utils from '@seeqdev/utils';

/**
 * @deprecated use `base64guid` from `@seeqdev/utils` instead
 */
export const base64guid = utils.base64guid;

/**
 * @deprecated use `validateGuid` from `@seeqdev/utils` instead
 */
export const validateGuid = utils.validateGuid;

/**
 * @deprecated use `extractGuids` from `@seeqdev/utils` instead
 */
export const extractGuids = utils.extractGuids;

/**
 * @deprecated use `randomUUID` from `@seeqdev/utils` instead
 */
export const randomUUID = utils.randomUUID;
